module.exports = __webpack_public_path__ + "5eb8e7dded059a1ebce71b09dce2f736.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2013.png
// module id = 536
// module chunks = 0